import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  Avatar,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Box,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Menu,
  MenuItem,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import ViewListIcon from "@mui/icons-material/ViewList";
import SortIcon from "@mui/icons-material/Sort";
import { motion, AnimatePresence } from "framer-motion";
import ReportService from "../Services/Service";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export default function VendorShowPage() {
  const [vendors, setVendors] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [hovered, setHovered] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [view, setView] = useState("card");
  const [sortOption, setSortOption] = useState("nameAsc");
  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    ReportService.setApiUrl(sessionStorage.getItem("APIUrl") + "/api/Report");
    fetchVendors();
  }, []);

  const navigate = useNavigate();

  const fetchVendors = async () => {
    try {
      //debugger;
      const res = await ReportService.getAll();
      setVendors(res.data);
    } catch (err) {
      console.error("Error fetching vendors", err);
    }
  };

  const handleOpen = (vendor) => {
    setSelectedVendor(vendor);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedVendor(null);
  };

  // ✅ Filter vendors
  // let filteredVendors = vendors.filter((vendor) =>
  //   [vendor.vendor, vendor.categoryGroup, vendor.station]
  //     .join(" ")
  //     .toLowerCase()
  //     .includes(searchTerm.toLowerCase()),
  // );

  let filteredVendors = vendors.filter((vendor) =>
    [
      vendor.vendor,
      vendor.categoryGroup,
      vendor.station,
      vendor.eventName,
      vendor.email,
      vendor.contactNumber,
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase()
      .includes(searchTerm.toLowerCase()),
  );
  // ✅ Sorting logic
  filteredVendors = [...filteredVendors].sort((a, b) => {
    switch (sortOption) {
      case "nameAsc":
        return a.vendor.localeCompare(b.vendor);
      case "nameDesc":
        return b.vendor.localeCompare(a.vendor);
      case "category":
        return a.categoryGroup.localeCompare(b.categoryGroup);
      case "station":
        return a.station.localeCompare(b.station);
      default:
        return 0;
    }
  });

  return (
    <div style={{ width: "100%", paddingLeft: 50, paddingRight: 50 }}>
      <Box
        sx={{
          maxWidth: "1260px",
          margin: "0 auto",
        }}
      >
        {/* <Box  ml={10}>
        <Button
          variant="contained"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate("/DashboardFinal")}
        >
          Back to Home
        </Button>
      </Box> */}

        {/* <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mb: 3,
          mt: 2,
          px: 3,
          alignItems: "center",
          flexWrap: "wrap",
          gap: 2,
        }}
      > */}
        {/* Search Box */}
        {/* <TextField
          label="Search Vendors"
          variant="outlined"
          size="small"
          sx={{ width: 260 }}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        /> */}

        {/* Right Controls */}
        {/* <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}> */}

        {/* Search + Sort + Toggle */}

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 5,
            mb: 3,
            mt: 2,
            flexWrap: "wrap",
          }}
        >
          <Box sx={{ display: "flex", gap: 31 }}>
            <Button
              variant="contained"
              startIcon={<ArrowBackIcon />}
              onClick={() => navigate("/DashboardFinal")}
            >
              Back to Home
            </Button>

            <TextField
              label="Search Vendors"
              variant="outlined"
              size="small"
              sx={{ width: 260 }}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Box>

          <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
            <SortIcon />
          </IconButton>

          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
          >
            <MenuItem
              onClick={() => {
                setSortOption("nameAsc");
                setAnchorEl(null);
              }}
            >
              Name (A–Z)
            </MenuItem>

            <MenuItem
              onClick={() => {
                setSortOption("nameDesc");
                setAnchorEl(null);
              }}
            >
              Name (Z–A)
            </MenuItem>

            <MenuItem
              onClick={() => {
                setSortOption("category");
                setAnchorEl(null);
              }}
            >
              Category
            </MenuItem>

            <MenuItem
              onClick={() => {
                setSortOption("station");
                setAnchorEl(null);
              }}
            >
              Station
            </MenuItem>
          </Menu>

          <ToggleButtonGroup
            value={view}
            exclusive
            onChange={(e, newView) => newView && setView(newView)}
            size="small"
            sx={{
              borderRadius: "30px",
              overflow: "hidden",
              boxShadow: 2,
            }}
          >
            <ToggleButton
              value="card"
              sx={{
                borderRadius: "30px",
                px: 3,
                py: 1,
                "&.Mui-selected": {
                  backgroundColor: "#1976d2",
                  color: "#fff",
                },
                "&:not(.Mui-selected)": {
                  backgroundColor: "#e3f2fd",
                  color: "#1976d2",
                },
              }}
            >
              <ViewModuleIcon />
            </ToggleButton>

            <ToggleButton
              value="grid"
              sx={{
                borderRadius: "30px",
                px: 3,
                py: 1,
                "&.Mui-selected": {
                  backgroundColor: "#2e7d32",
                  color: "#fff",
                },
                "&:not(.Mui-selected)": {
                  backgroundColor: "#e8f5e9",
                  color: "#2e7d32",
                },
              }}
            >
              <ViewListIcon />
            </ToggleButton>
          </ToggleButtonGroup>
        </Box>
        {/* AnimatePresence handles transitions */}
        <AnimatePresence mode="wait">
          {/* Card View */}
          {view === "card" && (
            <motion.div
              key="cardView"
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 30 }}
              transition={{ duration: 0.4 }}
            >
              <Box sx={{ maxHeight: "600px", overflowY: "auto", p: 2 }}>
                <Grid container spacing={3} justifyContent="center">
                  {filteredVendors.map((vendor, index) => (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                      <Card
                        sx={{
                          minWidth: 300,
                          maxWidth: 300,
                          height: 220, // ✅ fixed same size
                          borderRadius: "16px",
                          boxShadow: 3,
                          cursor: "pointer",
                          margin: "auto",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "center",
                          transition:
                            "transform 0.25s ease, box-shadow 0.25s ease",
                          "&:hover": {
                            boxShadow: 6,
                            transform: "translateY(-6px) scale(1.02)",
                            zIndex: 100,
                          },
                        }}
                        onClick={() => handleOpen(vendor)}
                        onMouseEnter={() => setHovered(index)}
                        onMouseLeave={() => setHovered(null)}
                      >
                        <CardContent
                          sx={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            textAlign: "center",
                            width: "100%",
                          }}
                        >
                          <Avatar
                            sx={{
                              bgcolor: "primary.main",
                              width: 56,
                              height: 56,
                              mb: 1,
                            }}
                          >
                            {vendor.vendor.charAt(0) || "N/A"}
                          </Avatar>
                          <Typography variant="h6" sx={{ mb: 1 }}>
                            {vendor.vendor || "N/A"}
                          </Typography>
                          {hovered === index ? (
                            <>
                              <Typography
                                variant="body2"
                                color="text.secondary"
                              >
                                📧 {vendor.email || "N/A"}
                              </Typography>
                              <Typography
                                variant="body2"
                                color="text.secondary"
                              >
                                📞 {vendor.contactNumber || "N/A"}
                              </Typography>
                            </>
                          ) : (
                            <Typography variant="body2" color="text.secondary">
                              Category: {vendor.categoryGroup || "N/A"}
                            </Typography>
                          )}
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </motion.div>
          )}

          {/* Grid View */}
          {view === "grid" && (
            <motion.div
              key="gridView"
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -30 }}
              transition={{ duration: 0.4 }}
            >
              <TableContainer
                component={Paper}
                sx={{
                  mt: 2,
                  maxHeight: "600px",
                  overflowY: "auto",
                }}
              >
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Vendor Name </TableCell>
                      <TableCell>Email</TableCell>
                      <TableCell>Contact</TableCell>
                      <TableCell>Station</TableCell>
                      <TableCell>Category</TableCell>
                      <TableCell>Event Name</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredVendors.map((vendor, index) => (
                      <TableRow
                        key={index}
                        hover
                        sx={{ cursor: "pointer" }}
                        onClick={() => handleOpen(vendor)}
                      >
                        <TableCell>{vendor.vendor || "N/A"}</TableCell>
                        <TableCell>{vendor.email || "N/A"}</TableCell>
                        <TableCell>{vendor.contactNumber || "N/A"}</TableCell>
                        <TableCell>{vendor.station || "N/A"}</TableCell>
                        <TableCell>{vendor.categoryGroup || "N/A"}</TableCell>
                        <TableCell>
                          {vendor.eventName && vendor.eventName.trim() !== ""
                            ? vendor.eventName
                            : "N/A"}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </motion.div>
          )}
        </AnimatePresence>

        {/* Vendor Details Modal */}
        <Dialog
          open={open}
          onClose={handleClose}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: { borderRadius: "16px", boxShadow: 6, padding: 2 },
          }}
        >
          <DialogTitle
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              pb: 1,
            }}
          >
            Vendor Details
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent
            dividers
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            {selectedVendor && (
              <>
                <Avatar
                  sx={{ bgcolor: "primary.main", width: 64, height: 64, mb: 2 }}
                >
                  {selectedVendor.vendor.charAt(0) || "N/A"}
                </Avatar>
                <Typography variant="h6" gutterBottom>
                  {selectedVendor.vendor || "N/A"}
                </Typography>
                <Typography variant="body1">
                  📧 {selectedVendor.email || "N/A"}
                </Typography>
                <Typography variant="body1">
                  📞 {selectedVendor.contactNumber || "N/A"}
                </Typography>
                <Typography variant="body1">
                  📍 {selectedVendor.station || "N/A"}
                </Typography>
                <Typography variant="body1">
                  🎉 Event: {selectedVendor.eventName || "N/A"}
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mt: 1 }}
                >
                  Category Group: {selectedVendor.categoryGroup || "N/A"}
                </Typography>

                {selectedVendor.materials && (
                  <>
                    <Typography variant="subtitle1" sx={{ mt: 2 }}>
                      Materials Supplied:
                    </Typography>
                    <List dense>
                      {selectedVendor.materials.map((mat, idx) => (
                        <ListItem key={idx}>
                          <ListItemText
                            primary={mat.name}
                            secondary={`Unit: ${mat.unit}`}
                          />
                        </ListItem>
                      ))}
                    </List>
                  </>
                )}
              </>
            )}
          </DialogContent>
        </Dialog>
      </Box>
    </div>
  );
}
